import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
};

const deleteEarlyRegistrationSlice = createSlice({
  name: "deleteEarlyRegistration",
  initialState,
  reducers: {
    setDeleteEarlyRegistrationId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetDeleteEarlyRegistrationId: (state) => {
      state.id = "";
    },
    deleteEarlyRegistrationStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    deleteEarlyRegistrationSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
    },

    deleteEarlyRegistrationFailed: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.ERROR;
    },
    resetDeleteEarlyRegistration: () => {
      return { ...initialState };
    },
  },
});

export const {
  setDeleteEarlyRegistrationId,
  resetDeleteEarlyRegistrationId,
  deleteEarlyRegistrationStart,
  deleteEarlyRegistrationSuccess,
  deleteEarlyRegistrationFailed,
  resetDeleteEarlyRegistration,
} = deleteEarlyRegistrationSlice.actions;

export default deleteEarlyRegistrationSlice.reducer;
